import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent, ref, toRefs, computed, onMounted, watch } from "@vue/composition-api";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useApplicationStoreGetters, useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import * as ApplicationsActions from "@Broker/@Modules/clients/applications/application/store/application-actions";
import { useI18n } from "vue-i18n-composable";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { showToast } from "@Shared/@Utils/constants";
export default defineComponent({
  name: "LifeInsuranceModal",
  components: {
    GenericModal,
    vSelectField,
    MaterialInput,
    SimpleButton
  },
  props: {
    clientUsername: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const applicantsChecked = ref([{
      index: 0,
      isChecked: true
    }]);
    const errorMsg = ref([]);
    const {
      t,
      tc
    } = useI18n();
    const sendingSubmitRequest = ref(false);
    const loadingProviders = ref(true);
    const consentChecked = ref(false);
    const lifeInsuranceModal = ref();
    const {
      clientUsername
    } = toRefs(props);
    const {
      CURRENT_APPLICATION,
      GET_INSURANCE_PROVIDERS
    } = useApplicationStoreGetters([ApplicationGetters.CURRENT_APPLICATION, ApplicationGetters.GET_INSURANCE_PROVIDERS]);
    const productDropdownValue = ref("");
    const providerDropdownValue = ref("");
    const {
      SUBMIT_INSURANCE_REQUEST,
      LOAD_INSURANCE_PROVIDERS
    } = useApplicationStoreActions([ApplicationsActions.SUBMIT_INSURANCE_REQUEST, ApplicationsActions.LOAD_INSURANCE_PROVIDERS]);
    const handleShow = async () => {
      var _lifeInsuranceModal$v;
      (_lifeInsuranceModal$v = lifeInsuranceModal.value) == null ? void 0 : _lifeInsuranceModal$v.show();
    };
    onMounted(async () => {
      try {
        await LOAD_INSURANCE_PROVIDERS();
      } finally {
        loadingProviders.value = false;
      }
    });
    const providerNameOptions = computed(() => (_GET_INSURANCE_PROVID => {
      const raw = (_GET_INSURANCE_PROVID = GET_INSURANCE_PROVIDERS.value) != null ? _GET_INSURANCE_PROVID : [];
      const providersArray = Array.isArray(raw) ? raw : (raw == null ? void 0 : raw.providers) || [];
      return _mapInstanceProperty(providersArray).call(providersArray, provider => ({
        label: provider.providerName || "",
        value: provider.providerId || "",
        products: provider.providerProducts || []
      }));
    })());
    const cleanData = () => {
      consentChecked.value = false;
      applicantsChecked.value.forEach((applicant, index) => {
        if (index !== 0) applicant.isChecked = false;
      });
      sendingSubmitRequest.value = false;
      if (Array.isArray(providerNameOptions.value) && providerNameOptions.value.length > 1) providerDropdownValue.value = "";
      if (Array.isArray(productNameOptions.value) && productNameOptions.value.length > 1) productDropdownValue.value = "";
    };
    const selectedProvider = computed(() => {
      var _context, _GET_INSURANCE_PROVID2;
      const val = providerDropdownValue.value;
      const fromOptions = _findInstanceProperty(_context = providerNameOptions.value).call(_context, p => String(p.value) === String(val));
      if (fromOptions) return fromOptions;
      const raw = (_GET_INSURANCE_PROVID2 = GET_INSURANCE_PROVIDERS.value) != null ? _GET_INSURANCE_PROVID2 : [];
      const providersArray = Array.isArray(raw) ? raw : (raw == null ? void 0 : raw.providers) || (raw == null ? void 0 : raw.data) || (raw == null ? void 0 : raw.items) || [];
      const found = _findInstanceProperty(providersArray).call(providersArray, prov => [prov.providerId].some(pv => String(pv) === String(val)));
      if (found) return {
        label: found.providerName || "",
        value: found.providerId || "",
        products: found.providerProducts || []
      };
      return undefined;
    });
    const productNameOptions = computed(() => {
      var _selectedProvider$val;
      const products = ((_selectedProvider$val = selectedProvider.value) == null ? void 0 : _selectedProvider$val.products) || [];
      return _mapInstanceProperty(products).call(products, product => _objectSpread({
        label: t(`provider-product-names.${product.productName}`) || t(`provider-product-names.${product.name}`) || "",
        value: product.productId ? String(product.productId) : product.id ? String(product.id) : ""
      }, product));
    });
    const selectProductName = productName => {
      productDropdownValue.value = productName.value;
    };
    const selectProviderName = providerName => {
      providerDropdownValue.value = providerName.value;
    };
    const coApplicants = computed(() => {
      var _CURRENT_APPLICATION$, _context2;
      return (_CURRENT_APPLICATION$ = CURRENT_APPLICATION.value) == null ? void 0 : _filterInstanceProperty(_context2 = _CURRENT_APPLICATION$["co-applicants"]).call(_context2, coApp => coApp["personal-details"]["co-applicant-type"] !== "guarantor");
    });
    const {
      coApplicantTypeOptions
    } = APPLICATION_FIELD_OPTIONS();
    const mapApplicantType = applicantType => {
      var _coApplicantTypeOptio;
      return (_coApplicantTypeOptio = _findInstanceProperty(coApplicantTypeOptions).call(coApplicantTypeOptions, option => option.value === applicantType)) == null ? void 0 : _coApplicantTypeOptio.label;
    };
    const getFullName = (firstName, lastName) => {
      var _context3;
      const names = _filterInstanceProperty(_context3 = [firstName, lastName]).call(_context3, Boolean);
      return names.length > 0 ? names.join(" ") : "";
    };
    const allApplicants = computed(() => {
      var _CURRENT_APPLICATION$2, _CURRENT_APPLICATION$3, _context4, _coApplicants$value, _context5;
      const main = {
        fullName: getFullName((_CURRENT_APPLICATION$2 = CURRENT_APPLICATION.value) == null ? void 0 : _CURRENT_APPLICATION$2["main-applicant"]["personal-details"]["first-name"], (_CURRENT_APPLICATION$3 = CURRENT_APPLICATION.value) == null ? void 0 : _CURRENT_APPLICATION$3["main-applicant"]["personal-details"]["last-name"]),
        applicantType: t("application-form.primary-applicant"),
        username: clientUsername.value
      };
      const coApps = _mapInstanceProperty(_context4 = (_coApplicants$value = coApplicants.value) != null ? _coApplicants$value : []).call(_context4, coApp => ({
        fullName: getFullName(coApp["personal-details"]["first-name"], coApp["personal-details"]["last-name"]),
        applicantType: coApp["personal-details"]["co-applicant-type"] === "applicant" ? t("application-form.co-applicant") : mapApplicantType(coApp["personal-details"]["co-applicant-type"]),
        username: coApp.id
      }));
      return _filterInstanceProperty(_context5 = [main, ...coApps]).call(_context5, applicant => applicant.fullName !== "" || applicant.applicantType);
    });
    watch(allApplicants, apps => {
      applicantsChecked.value = _mapInstanceProperty(apps).call(apps, (_, idx) => ({
        index: idx,
        isChecked: idx === 0
      }));
    }, {
      immediate: true
    });
    watch(providerNameOptions, options => {
      if (Array.isArray(options) && options.length === 1) {
        providerDropdownValue.value = options[0].value;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(productNameOptions, options => {
      if (Array.isArray(options) && options.length === 1) {
        productDropdownValue.value = options[0].value;
      }
    }, {
      immediate: true,
      deep: true
    });
    const handleSubmitRequest = async () => {
      var _context6, _context7;
      const coApplicants = _mapInstanceProperty(_context6 = _filterInstanceProperty(_context7 = allApplicants.value).call(_context7, (_, index) => index !== 0 && applicantsChecked.value[index].isChecked)).call(_context6, applicant => applicant.username);
      const productId = productDropdownValue.value;
      const providerId = providerDropdownValue.value;
      sendingSubmitRequest.value = true;
      errorMsg.value = [];
      const {
        res
      } = await SUBMIT_INSURANCE_REQUEST({
        clientUsername: clientUsername.value,
        data: {
          providerId,
          productId,
          coApplicants
        }
      });
      if (res && res.status === 400) {
        errorMsg.value = res.responseJSON.insuranceValidationErrors;
      } else {
        var _lifeInsuranceModal$v2;
        (_lifeInsuranceModal$v2 = lifeInsuranceModal.value) == null ? void 0 : _lifeInsuranceModal$v2.hide();
        showToast("success", tc("application-form.submitRequestSuccess"));
      }
      sendingSubmitRequest.value = false;
      cleanData();
    };
    const handleHidden = () => {
      errorMsg.value = [];
      cleanData();
    };
    return {
      consentChecked,
      applicantsChecked,
      lifeInsuranceModal,
      providerNameOptions,
      productNameOptions,
      coApplicants,
      allApplicants,
      productDropdownValue,
      providerDropdownValue,
      selectProviderName,
      selectProductName,
      handleShow,
      handleSubmitRequest,
      sendingSubmitRequest,
      loadingProviders,
      errorMsg,
      handleHidden
    };
  }
});